import { Accordion, Hamburger, MobileMenuDrawer } from '@doodl/slate';
import { library, dom } from "@fortawesome/fontawesome-svg-core";
import { faChevronDown, faArrowRight, faDownload, faArrowLeft } from "@fortawesome/free-solid-svg-icons";
import Map from "./map";
import Carousel from "./carousel";
import loadZohoForm from './zoho/index.js';
import ReactForm from "./react-form";

const menuDrawer = new MobileMenuDrawer();

new Hamburger({
    onOpen: () => {
        menuDrawer.open();
    },
    onClose: () => {
        menuDrawer.close();
    },
});

Carousel(".image-carousel", {
    type: 'loop',
    focus: 'center',
    autoWidth: true,
    autoplay: true,
    interval: 4000,
    flickMaxPages: 3,
    updateOnMove: true,
    pagination: false,
    throttle: 300,
});

new Accordion({
    selector: ".mobile-menu-drawer--items .has-children .menu-item--children, .faqblock--wrapper .faqblock--content",
    toggleHTML: '<i class="fas fa-chevron-down"></i>',
});

// Lazy loads map lib if map holder detected
Map('.map--holder', {
    cooperativeGestures: true,
    center: [173.416630609886, -40.634012517793536],
    zoom: 5,
    addMarkers: (Marker) => ({ target: mapInstance }) => {

        document.querySelectorAll('[data-long-lat]').forEach(el => {
            const longLat = el.getAttribute('data-long-lat').split(',');
            const marker = document.createElement('div');
            marker.className = 'marker';

            new Marker(marker)
                .setLngLat(longLat)
                .addTo(mapInstance);
        });
    }
});

library.add(faChevronDown, faArrowLeft, faArrowRight, faDownload);

const navbar = document.getElementById('navbar');
const isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);

if (navbar) {
    if (isMobile) {
        navbar.classList.remove('nav-menu--list', 'nav-menu--list--level-0', 'nav-menu--list--flex');
        navbar.classList.add('menu-bar--items');
    } else {
        navbar.classList.add('nav-menu--list', 'nav-menu--list--level-0', 'nav-menu--list--flex');
        navbar.classList.remove('menu-bar--items');
    }
}

const formContainer = document.getElementById('form-container');

if (formContainer) {
    const formUrl = formContainer.getAttribute('data-form');
    const height = formContainer.getAttribute('data-height');
    const width = formContainer.getAttribute('data-width');
    loadZohoForm(formUrl, height, width);
}

ReactForm();

dom.watch();
